module.exports = __webpack_public_path__ + "img/MY.e85838a4.png";